import { render, staticRenderFns } from "./Bimini_foodItem.vue?vue&type=template&id=4394fb6c&scoped=true"
import script from "./Bimini_foodItem.vue?vue&type=script&lang=ts"
export * from "./Bimini_foodItem.vue?vue&type=script&lang=ts"
import style0 from "./Bimini_foodItem.vue?vue&type=style&index=0&id=4394fb6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4394fb6c",
  null
  
)

export default component.exports